import { Role, ShoppingVillage } from '@/constants';
import usePrefix from '@/hooks/usePrefix';
import { useReadyInfo } from '@/providers/ReadyProvider';
import React from 'react';
import { Button } from 'rsuite';
import Image from '../Bicester/Image';

const defaultAvatar = '/resources/images/avatar-default.svg';
const Profile = ({ onLogout }: { onLogout: () => void }) => {
  const { classname, prefix } = usePrefix('bicester-header-profile');
  const { profile } = useReadyInfo();
  const { user_name, avatar = defaultAvatar, service_site_name, role, shopping_village } = profile;

  return (
    <>
      <div className={classname}>
        <div className={prefix('avatar')}>
          <Image src={avatar || defaultAvatar} />
        </div>
        <div className={prefix('info')}>
          <div className={prefix('info-username')}>{user_name}</div>
          <div className={prefix('info-identity')}>
            {role && Role[role] && <div>{Role[role]}</div>}
            {role && service_site_name && <div className="mx-[8px]">|</div>}
            <div>{`${ShoppingVillage[shopping_village]}-${service_site_name}`}</div>
            <div className="mx-[8px]">|</div>
            <Button className={prefix('info-identity-logout')} appearance="link" onClick={onLogout}>
              登出
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
